import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { getBuildConfig } from 'app-components/utils/core';

const Hotjar = () => {
  const featureFlagsError = useSelector(featureFlagsSelectors.getError);
  const featureFlagsLoadPending = useSelector(featureFlagsSelectors.getLoadPending);
  const hotjarFlag = useSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'hotjar'));

  useEffect(() => {
    if ((!featureFlagsLoadPending || featureFlagsError) && hotjarFlag) {
      const hotjarKey = getBuildConfig()?.hotjar_key;
      /* eslint-disable */
      try {
        (function (h, o, t, j, a, r) {
          h.hj =
            h.hj ||
            function () {
              (h.hj.q = h.hj.q || []).push(arguments);
            };
          h._hjSettings = { hjid: hotjarKey, hjsv: 6 };
          a = o.getElementsByTagName('head')[0];
          r = o.createElement('script');
          r.async = 1;
          r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
          a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
      } catch (error) {
        assert(false, error);
      }
      /* eslint-enable */
    }
  }, [featureFlagsLoadPending, featureFlagsError, hotjarFlag]);

  return null;
};

export default Hotjar;
